import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faHome,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  Breadcrumb,
  Nav,
  Tab,
} from "@themesberg/react-bootstrap";
import axios from "axios";
import { Modal } from "@themesberg/react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { Routes } from "../../routes";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import BASE_URL from "../../config";

const Addapplication = () => {
  const [activeTab, setActiveTab] = useState("Merchant"); // State to manage active tab
  const [formData, setFormData] = useState({
    // State to manage form data
    user_type: "",
    application_status: "",
    company_name: "",
    company_address: "",
    company_city: "",
    company_state: "",
    company_zipcode: "",
    company_country: "",
    website_url: "",
    product: "",
    descriptor: "",
    manager_full_name: "",
    manager_address: "",
    manager_city: "",
    manager_state: "",
    manager_zipcode: "",
    manager_phone: "",
    manager_AltPhone: "",
    manager_email: "",
    manager_skype_id: "",
    manager_passport: "",
    SSN: "",
    contactname: "",
    tollfreeno: "",
    contactemail: "",
    credit_card: "",
    processed_before: "",
    merchant_account_termination_status: "",
    merchant_account_termination_reason: "",
    processor: "",
    time_with_processor: "",
    total_sales: "",
    no_of_trans_per_mnth: "",
    minimum_ticket_amount: "",
    maximum_ticket_amount: "",
    account_holder_name: "",
    account_holder_address: "",
    account_holder_country: "",
    bank_name: "",
    bank_address: "",
    bank_country: "",
    bank_swift: "",
    bank_routing_no: "",
    bank_account_number: "",
    bank_additional_info: "",
    about_us: "",
    agent_name: "",
  });
  const [errors, setErrors] = useState({}); // State to manage form errors
  const [showPopup, setShowPopup] = useState(false); // Popup visibility
  const [popupType, setPopupType] = useState(""); // Popup type: "success" or "error"
  const [popupMessage, setPopupMessage] = useState(""); // Popup message
  const history = useHistory();
  const [loggedInUserType, setLoggedInUserType] = useState(null); // Store logged-in user type

  const RequiredLabel = ({ children }) => (
    <Form.Label>
      {children} <span className="text-danger">*</span>
    </Form.Label>
  );

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    const user = authToken ? JSON.parse(authToken) : null;
    if (user) {
      setLoggedInUserType(user.user_type);
      if (user.user_type === "2" && activeTab === "Merchant") {
        setActiveTab("Company");
      }
    }
  }, []);

  // Validate form fields
  const validateForm = (fieldsToValidate = []) => {
    const patterns = {
      phone: /^[0-9]{10}$/, // 10-digit phone number
      zipcode: /^[0-9]{6}$/, // ZIP code format
      url: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}\/?$/, // URL validation
      email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Simple email validation
      numeric: /^[0-9]+$/, // Numeric values
    };
  
    // Fields to skip validation
    const nonRequiredFields = [
      "application_status",
      "bank_account_number",
      "user_type",
      "credit_card", 
      "processed_before", 
      "merchant_account_termination_status",
      "merchant_account_termination_reason",
      "processor",
      "time_with_processor",
      "website_url",
      "product",
      "descriptor",
      "manager_skype_id",
      "manager_passport",
      "SSN",
      "contactname",
      "tollfreeno",
      "contactemail",
      "total_sales",
      "no_of_trans_per_mnth",
      "minimum_ticket_amount",
      "maximum_ticket_amount",
      "bank_swift",
      "bank_routing_no",
      "bank_account_number",
      "bank_additional_info",
    //   "merchant_account_termination_reason",
    //   "processor",
    //   "time_with_processor",
    //   "total_sales",
    //   "no_of_trans_per_mnth",
    //   "minimum_ticket_amount",
    //   "maximum_ticket_amount",
    ]; // Fields in Processing and Transaction tabs
  
    const newErrors = {};
  
    fieldsToValidate.forEach((field) => {
      const value = formData[field];
  
      // Skip validation for non-required fields
      if (nonRequiredFields.includes(field)) {
        return;
      }
  
      // Required field validation
      if (!value) {
        newErrors[field] = `${field.replace(/_/g, " ")} is required`;
        return;
      }
  
      // Custom validation for specific patterns
      if (
        ["manager_phone", "manager_AltPhone", "tollfreeno"].includes(field) &&
        !patterns.phone.test(value)
      ) {
        newErrors[field] = "Invalid phone number. Must be 10 digits.";
      }
  
      if (
        ["company_zipcode", "manager_zipcode"].includes(field) &&
        !patterns.zipcode.test(value)
      ) {
        newErrors[field] = "Invalid ZIP code format.";
      }
  
      if (field === "website_url" && !patterns.url.test(value)) {
        newErrors[field] = "Invalid website URL.";
      }
  
      if (
        ["manager_email", "contactemail"].includes(field) &&
        !patterns.email.test(value)
      ) {
        newErrors[field] = "Invalid email address.";
      }
  
      if (
        [
          "total_sales",
          "no_of_trans_per_mnth",
          "minimum_ticket_amount",
          "maximum_ticket_amount",
        ].includes(field) &&
        !patterns.numeric.test(value)
      ) {
        newErrors[field] = `${field.replace(/_/g, " ")} must be a numeric value.`;
      }
    });
  
    return newErrors;
  };
  
  
  
  

  // Handle form changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Function to handle switching to the next tab
  const handleNextClick = () => {
    // Define tab-specific required fields
    const tabSpecificFields = {
      Merchant: ["user_type", "application_status"],
      Company: [
        "company_name",
        "company_address",
        "company_city",
        "company_state",
        "company_zipcode",
        "company_country",
      ],
      Website: [],
      Manager: [
        "manager_full_name",
        "manager_address",
        "manager_city",
        "manager_state",
        "manager_zipcode",
        "manager_phone",
        "manager_AltPhone",
        "manager_email",
        "manager_skype_id",
        "manager_passport",
        "SSN",
      ],
      Customer: [],
      Processing: [],
      Transaction: [],
      Bank: [
        "account_holder_name",
        "account_holder_address",
        "account_holder_country",
        "bank_name",
        "bank_address",
        "bank_country",
      ],
      Other: ["about_us", "agent_name"],
    };

    // Get required fields for the current tab
    const requiredFieldsForCurrentTab = tabSpecificFields[activeTab] || [];

    // Validate fields in the current tab
    const currentTabErrors = validateForm(requiredFieldsForCurrentTab);

    if (Object.keys(currentTabErrors).length > 0) {
      setErrors(currentTabErrors);
      setPopupType("error");
      setPopupMessage("Please fix the errors before proceeding.");
      setShowPopup(true);
      return;
    }

    // If no validation errors, move to the next tab
    const tabs = [
      "Merchant",
      "Company",
      "Website",
      "Manager",
      "Customer",
      "Processing",
      "Transaction",
      "Bank",
      "Other",
    ];
    const currentIndex = tabs.indexOf(activeTab);
    setActiveTab(tabs[currentIndex + 1]);
  };

  // const validateForm = (fieldsToValidate) => {
  //   const patterns = {
  //     phone: /^[0-9]{10}$/, // 10-digit phone number
  //     zipcode: /^[0-9]{6}$/, // ZIP code format
  //     url: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}\/?$/, // URL validation
  //     email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Simple email validation
  //   };

  //   const newErrors = {};

  //   // Validate each field in the provided list
  //   Object.keys(fieldsToValidate).forEach((field) => {
  //     const value = fieldsToValidate[field];

  //     // Required field validation
  //     if (!value) {
  //       newErrors[field] = `${field.replace(/_/g, " ")} is required`;
  //       return;
  //     }

  //     // Custom validation for specific fields
  //     if (
  //       field === "manager_phone" ||
  //       field === "manager_AltPhone" ||
  //       field === "tollfreeno"
  //     ) {
  //       if (!patterns.phone.test(value)) {
  //         newErrors[field] = "Invalid phone number. Must be 10 digits.";
  //       }
  //     }
  //     if (field === "company_zipcode" || field === "manager_zipcode") {
  //       if (!patterns.zipcode.test(value)) {
  //         newErrors[field] = "Invalid ZIP code format.";
  //       }
  //     }
  //     if (field === "website_url") {
  //       if (!patterns.url.test(value)) {
  //         newErrors[field] = "Invalid website URL.";
  //       }
  //     }
  //     if (field === "manager_email" || field === "contactemail") {
  //       if (!patterns.email.test(value)) {
  //         newErrors[field] = "Invalid email address.";
  //       }
  //     }
  //   });

  //   return newErrors;
  // };

  // Function to handle switching to the previous tab
  const handlePreviousClick = () => {
    const tabs = [
      "Merchant",
      "Company",
      "Website",
      "Manager",
      "Customer",
      "Processing",
      "Transaction",
      "Bank",
      "Other",
    ];
    const currentIndex = tabs.indexOf(activeTab);
    if (currentIndex > 0) {
      setActiveTab(tabs[currentIndex - 1]);
    }
  };

  // Function to handle form submission
  // const handleSubmit = async () => {
  //   // console.log(formData);
  //   try {
  //     const response = await axios.post('http://localhost:8000/api.php', {
  //       type: 'applications', // Type for application
  //       ...formData
  //     });

  //     if (response.data && response.data.message) {
  //       alert(response.data.message); // Success message

  //     }
  //   } catch (error) {
  //     console.error("Error saving application:", error);
  //     alert('An error occurred while saving the application. Please try again.');
  //   }
  // };
  const Popup = ({ type, message, onClose }) => (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "rgba(255, 255, 255, 0.9)",
        borderRadius: "10px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        padding: "20px 30px",
        zIndex: 1050,
        textAlign: "center",
      }}
    >
      <FontAwesomeIcon
        icon={type === "success" ? faCheckCircle : faThumbsUp}
        className={type === "success" ? "text-success" : "text-danger"}
        size="3x"
      />
      <h5 className="mt-3 fw-bold">{message}</h5>
      <Button
        variant={type === "success" ? "success" : "danger"}
        className="mt-3"
        onClick={onClose}
      >
        {type === "success" ? "Go to Dashboard" : "Close"}
      </Button>
    </div>
  );

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const validationErrors = validateForm();
  //   if (Object.keys(validationErrors).length > 0) {
  //     console.log("Validation Errors:", validationErrors);
  //     setErrors(validationErrors);
  //     setShowModal(true);
  //     return;
  //   }
  //   try {
  //     // Get the authToken from localStorage
  //     const authToken = localStorage.getItem("authToken");

  //     // Parse the authToken to extract user information (assuming it's JSON formatted)
  //     const user = authToken ? JSON.parse(authToken) : null;

  //     // Check if user information is available
  //     if (!user || !user.id || !user.email) {
  //       alert("User is not logged in or session has expired.");
  //       return;
  //     }

  //     // Combine user data with form data
  //     const requestData = {
  //       type: "applications", // Type for application
  //       user_id: user.id, // Send user ID from session/localStorage
  //       user_email: user.email, // Send user email from session/localStorage
  //       ...formData, // Add form data
  //     };

  //     // Make the POST request to the backend with the combined data
  //     const response = await axios.post("/api.php", requestData);

  //     // Handle the response
  //     if (response.data && response.data.message) {
  //       // alert(response.data.message); // Success message
  //       setShowSuccessModal(true);
  //       // Clear form data
  //       setFormData({
  //         user_type: "",
  //         application_status: "",
  //         company_name: "",
  //         company_address: "",
  //         company_city: "",
  //         company_state: "",
  //         company_zipcode: "",
  //         company_country: "",
  //         website_url: "",
  //         product: "",
  //         descriptor: "",
  //         manager_full_name: "",
  //         manager_address: "",
  //         manager_city: "",
  //         manager_state: "",
  //         manager_zipcode: "",
  //         manager_phone: "",
  //         manager_AltPhone: "",
  //         manager_email: "",
  //         manager_skype_id: "",
  //         manager_passport: "",
  //         SSN: "",
  //         contactname: "",
  //         tollfreeno: "",
  //         contactemail: "",
  //         credit_card: "",
  //         processed_before: "",
  //         merchant_account_termination_status: "",
  //         merchant_account_termination_reason: "",
  //         processor: "",
  //         time_with_processor: "",
  //         total_sales: "",
  //         no_of_trans_per_mnth: "",
  //         minimum_ticket_amount: "",
  //         maximum_ticket_amount: "",
  //         account_holder_name: "",
  //         account_holder_address: "",
  //         account_holder_country: "",
  //         bank_name: "",
  //         bank_address: "",
  //         bank_country: "",
  //         bank_swift: "",
  //         bank_routing_no: "",
  //         bank_account_number: "",
  //         bank_additional_info: "",
  //         about_us: "",
  //         agent_name: "",
  //       });

  //       // Optionally, reset the active tab to the first tab
  //       setActiveTab("Merchant");
  //     }
  //   } catch (error) {
  //     console.error("Error saving application:", error);
  //     alert(
  //       "An error occurred while saving the application. Please try again."
  //     );
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Pass all form fields for validation if submitting the form
    const validationErrors = validateForm(Object.keys(formData));
    console.log("Validation Results:", validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setPopupType("error");
      setPopupMessage("Please fill in all required fields.");
      setShowPopup(true);
      return;
    }
  
    try {
      const authToken = localStorage.getItem("authToken");
      const user = authToken ? JSON.parse(authToken) : null;
      if (!user || !user.id || !user.email) {
        setPopupType("error");
        setPopupMessage("User is not logged in or session has expired.");
        setShowPopup(true);
        return;
      }
  
      const response = await axios.post(`${BASE_URL}/api.php`, {
        type: "applications",
        user_id: user.id,
        user_email: user.email,
        ...formData,
      });
  
      if (response.data && response.data.status === "success") {

      console.log("Application response:", response.data);

      if (response.data.email_status === "sent") {

        setPopupType("success");
        setPopupMessage(
          `Application saved successfully and confirmation email has been sent. Application ID: ${response.data.application_id}`
        );

      } else if (response.data.email_status === "failed") {

        console.error("Email error:", response.data.email_error);

        setPopupType("success");
        setPopupMessage(
          `Application saved successfully, but confirmation email could not be sent. Application ID: ${response.data.application_id}`
        );

      } else {

        setPopupType("success");
        setPopupMessage(
          `Application saved successfully. Application ID: ${response.data.application_id}`
        );
      }

      setShowPopup(true);

      // Reset form
      setFormData({
        user_type: "",
        application_status: "",
        company_name: "",
        company_address: "",
        company_city: "",
        company_state: "",
        company_zipcode: "",
        company_country: "",
        website_url: "",
        product: "",
        descriptor: "",
        manager_full_name: "",
        manager_address: "",
        manager_city: "",
        manager_state: "",
        manager_zipcode: "",
        manager_phone: "",
        manager_AltPhone: "",
        manager_email: "",
        manager_skype_id: "",
        manager_passport: "",
        SSN: "",
        contactname: "",
        tollfreeno: "",
        contactemail: "",
        credit_card: "",
        processed_before: "",
        merchant_account_termination_status: "",
        merchant_account_termination_reason: "",
        processor: "",
        time_with_processor: "",
        total_sales: "",
        no_of_trans_per_mnth: "",
        minimum_ticket_amount: "",
        maximum_ticket_amount: "",
        account_holder_name: "",
        account_holder_address: "",
        account_holder_country: "",
        bank_name: "",
        bank_address: "",
        bank_country: "",
        bank_swift: "",
        bank_routing_no: "",
        bank_account_number: "",
        bank_additional_info: "",
        about_us: "",
        agent_name: "",
      });

      setActiveTab("Merchant");
    }
    } catch (error) {
      setPopupType("error");
      setPopupMessage(
        "An error occurred while saving the application. Please try again."
      );
      setShowPopup(true);
    }
  };
  
  const handlePopupClose = () => {
    setShowPopup(false);
    if (popupType === "success") {
      history.push(Routes.DashboardOverview.path); // Redirect to dashboard
    }
  };
  return (
    <>
      {/* Popup */}
      {showPopup && (
        <Popup
          type={popupType}
          message={popupMessage}
          onClose={handlePopupClose}
        />
      )}

      {/* Breadcrumb and title */}
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mt-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <Link to={"/dashboard/overview"}><FontAwesomeIcon icon={faHome} /></Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>New Application</Breadcrumb.Item>
          </Breadcrumb>
          <h4>New Application</h4>
        </div>
      </div>

      {/* Main card container */}
      <Card border="light" className="bg-white  mb-4">
        <Card.Body>
          {/* Tab navigation and content */}
          <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
            <Row>
              {/* Left sidebar with tabs */}
              <Col lg={3}>
                <Nav fill variant="pills" className="flex-column vertical-tab">
                  {loggedInUserType !== "2" && (
                    <Nav.Item>
                      <Nav.Link eventKey="Merchant">
                        Merchant Application Status
                      </Nav.Link>
                    </Nav.Item>
                  )}

                  <Nav.Item>
                    <Nav.Link eventKey="Company">Company Information</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="Website">Website Information</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="Manager">
                      Manager Owner Information
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="Customer">
                      Customer Service Information
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="Processing">
                      Processing History
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="Transaction">
                      Transaction Information
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="Bank">Bank Information</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="Other">Other Information</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>

              {/* Right content area */}
              <Col lg={9}>
                <Tab.Content>
                  {/* Merchant tab content */}
                  <Tab.Pane eventKey="Merchant">
                    <Form>
                      <Row>
                        <Col md={12} className="mb-3">
                          <Form.Group className="mb-3">
                            <Form.Label>Merchant</Form.Label>
                            <Form.Select
                              defaultValue="0"
                              name="user_type"
                              value={formData.user_type}
                              onChange={handleChange}
                              isInvalid={!!errors.user_type} // Add error check
                            >
                              <option value="0">Administrator</option>
                              <option value="1">Merchant</option>
                              <option value="2">Manager</option>
                              <option value="3">Third Party Vendor</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.user_type}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mb-3">
                          <Form.Group id="application">
                            <Form.Label>Application Status</Form.Label>
                            <Form.Select
                              defaultValue="0"
                              name="application_status"
                              value={formData.application_status}
                              onChange={handleChange}
                              isInvalid={!!errors.application_status} // Add error check
                            >
                              <option value="0">Application Approved</option>
                              <option value="1">Application Declined</option>
                              <option value="2">Application Suspended</option>
                              <option value="3">Incomplete Application</option>
                              <option value="4">Waiting For Merchant</option>
                              <option value="5">Waiting For Bank</option>
                              <option value="4">Waiting For Agent</option>
                              <option value="4">Application Applied</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.application_status}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <hr />
                        <div className="mt-3 text-end">
                          <Button variant="primary" onClick={handleNextClick}>
                            Next{" "}
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="ml-2"
                            />
                          </Button>
                        </div>
                      </Row>
                    </Form>
                  </Tab.Pane>

                  {/* Company tab content */}
                  <Tab.Pane eventKey="Company">
                    <Form>
                      {/* Add more fields as needed */}

                      <Row>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Name">
                            <RequiredLabel>Company Name</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              name="company_name"
                              placeholder="Enter company name"
                              value={formData.company_name}
                              onChange={handleChange}
                              isInvalid={!!errors.company_name} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.company_name}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Address">
                            <RequiredLabel>Company Address</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter company address"
                              name="company_address"
                              value={formData.company_address}
                              onChange={handleChange}
                              isInvalid={!!errors.company_address} // Add error check
                            />
                          </Form.Group>
                          <Form.Control.Feedback type="invalid">
                            {errors.company_address}
                          </Form.Control.Feedback>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="City">
                            <RequiredLabel>Company City/Town</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter company city/town"
                              name="company_city"
                              value={formData.company_city}
                              onChange={handleChange}
                              isInvalid={!!errors.company_city} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.company_city}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="State">
                            <RequiredLabel>Company State</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter company state"
                              name="company_state"
                              value={formData.company_state}
                              onChange={handleChange}
                              isInvalid={!!errors.company_state} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.company_state}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Zipcode">
                            <RequiredLabel>Company Zipcode</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter company zipcode"
                              name="company_zipcode"
                              value={formData.company_zipcode}
                              onChange={handleChange}
                              isInvalid={!!errors.company_zipcode} // Add error check
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-4">
                          <Form.Group id="Country">
                            <RequiredLabel>Company Country</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter company country"
                              name="company_country"
                              value={formData.company_country}
                              onChange={handleChange}
                              isInvalid={!!errors.company_country} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.company_country}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <hr />
                        <Col md={6}>
                          <Button
                            variant="primary"
                            onClick={handlePreviousClick}
                          >
                            <FontAwesomeIcon
                              icon={faArrowLeft}
                              className="me-1"
                            />{" "}
                            Previous
                          </Button>
                        </Col>
                        <Col md={6} className="text-end">
                          <Button variant="primary" onClick={handleNextClick}>
                            Next{" "}
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="ml-2"
                            />
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Tab.Pane>

                  {/* Website tab content */}
                  <Tab.Pane eventKey="Website">
                    <Form>
                      {/* Website information fields */}
                      <Col md={12} className="mb-3">
                        <Form.Group id="websiteurl">
                          <RequiredLabel>Website URL</RequiredLabel>
                          <Form.Control
                            type="text"
                            placeholder="Enter website url"
                            name="website_url"
                            value={formData.website_url}
                            onChange={handleChange}
                            isInvalid={!!errors.website_url} // Add error check
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.website_url}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={12} className="mb-3">
                        <Form.Group id="Address">
                          <RequiredLabel>Product/Service</RequiredLabel>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter product/service"
                            name="product"
                            value={formData.product}
                            onChange={handleChange}
                            isInvalid={!!errors.product} // Add error check
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.product}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={12} className="mb-3">
                        <Form.Group id="Descriptor">
                          <RequiredLabel>Description</RequiredLabel>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter descriptor"
                            name="descriptor"
                            value={formData.descriptor}
                            onChange={handleChange}
                            isInvalid={!!errors.descriptor} // Add error check
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.descriptor}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <hr />
                      <Row>
                        <Col md={6}>
                          <Button
                            variant="primary"
                            onClick={handlePreviousClick}
                          >
                            <FontAwesomeIcon
                              icon={faArrowLeft}
                              className="me-1"
                            />{" "}
                            Previous
                          </Button>
                        </Col>
                        <Col md={6} className="text-end">
                          <Button variant="primary" onClick={handleNextClick}>
                            Next{" "}
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="ml-2"
                            />
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Tab.Pane>

                  {/* Manager tab content */}
                  <Tab.Pane eventKey="Manager">
                    <Form>
                      {/* Manager information fields */}

                      <Row>
                        <Col md={6} className="mb-3">
                          <Form.Group id="FullName">
                            <RequiredLabel>Full Name</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter full name"
                              name="manager_full_name"
                              value={formData.manager_full_name}
                              onChange={handleChange}
                              isInvalid={!!errors.manager_full_name} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.manager_full_name}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="MAddress">
                            <RequiredLabel> Address</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter  address"
                              name="manager_address"
                              value={formData.manager_address}
                              onChange={handleChange}
                              isInvalid={!!errors.manager_address} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.manager_address}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Citytown">
                            <RequiredLabel> City/Town</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter  city/town"
                              name="manager_city"
                              value={formData.manager_city}
                              onChange={handleChange}
                              isInvalid={!!errors.manager_city} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.manager_city}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="MState">
                            <RequiredLabel> State</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter  state"
                              name="manager_state"
                              value={formData.manager_state}
                              onChange={handleChange}
                              isInvalid={!!errors.manager_state} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.manager_state}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="MZipcode">
                            <RequiredLabel>Company Zipcode</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter zipcode"
                              name="manager_zipcode"
                              value={formData.manager_zipcode}
                              onChange={handleChange}
                              isInvalid={!!errors.manager_zipcode} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.manager_zipcode}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-4">
                          <Form.Group id="Cellphone">
                            <RequiredLabel>Cell Phone</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter cell phone"
                              name="manager_phone"
                              value={formData.manager_phone}
                              onChange={handleChange}
                              isInvalid={!!errors.manager_phone} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.manager_phone}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-4">
                          <Form.Group id="Alternatephone">
                            <RequiredLabel>Alternate Phone</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter alternate  phone"
                              name="manager_AltPhone"
                              value={formData.manager_AltPhone}
                              onChange={handleChange}
                              isInvalid={!!errors.manager_AltPhone} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.manager_AltPhone}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-4">
                          <Form.Group id="Emailadd">
                            <RequiredLabel>Email Address</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter email address"
                              name="manager_email"
                              value={formData.manager_email}
                              onChange={handleChange}
                              isInvalid={!!errors.manager_email} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.manager_email}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Skypeid">
                            <RequiredLabel>Skype Id</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter Skype id"
                              name="manager_skype_id"
                              value={formData.manager_skype_id}
                              onChange={handleChange}
                              isInvalid={!!errors.manager_skype_id} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.manager_skype_id}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Passportid">
                            <RequiredLabel>Passport / Driver ID#</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter passport / driver ID#"
                              name="manager_passport"
                              value={formData.manager_passport}
                              onChange={handleChange}
                              isInvalid={!!errors.manager_passport} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.manager_passport}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="ssnein">
                            <RequiredLabel>SSN / EIN</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter SSN / EIN"
                              value={formData.SSN}
                              name="SSN"
                              onChange={handleChange}
                              isInvalid={!!errors.SSN} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.SSN}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <hr />
                        <Col md={6}>
                          <Button
                            variant="primary"
                            onClick={handlePreviousClick}
                          >
                            <FontAwesomeIcon
                              icon={faArrowLeft}
                              className="me-1"
                            />{" "}
                            Previous
                          </Button>
                        </Col>
                        <Col md={6} className="text-end">
                          <Button variant="primary" onClick={handleNextClick}>
                            Next{" "}
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="ml-2"
                            />
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Tab.Pane>

                  {/* Customer tab content */}
                  <Tab.Pane eventKey="Customer">
                    <Form>
                      {/* Customer information fields */}

                      <Row>
                        <Col md={12} className="mb-3">
                          <Form.Group id="contactname">
                            <RequiredLabel>Contact Name</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter contact name"
                              value={formData.contactname}
                              onChange={handleChange}
                              name="contactname"
                              isInvalid={!!errors.contactname} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.contactname}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mb-3">
                          <Form.Group id="tollfreeno">
                            <RequiredLabel>Toll Free Number</RequiredLabel>
                            <Form.Control
                              type="text"
                              placeholder="Enter toll free number"
                              value={formData.tollfreeno}
                              onChange={handleChange}
                              name="tollfreeno"
                              isInvalid={!!errors.tollfreeno} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.tollfreeno}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mb-3">
                          <Form.Group id="contactemail">
                            <RequiredLabel>Contact Email</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter contact Email"
                              value={formData.contactemail}
                              name="contactemail"
                              onChange={handleChange}
                              isInvalid={!!errors.contactemail} // Add error check
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.contactemail}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <hr />
                        <Col md={6}>
                          <Button
                            variant="primary"
                            onClick={handlePreviousClick}
                          >
                            <FontAwesomeIcon
                              icon={faArrowLeft}
                              className="me-1"
                            />{" "}
                            Previous
                          </Button>
                        </Col>
                        <Col md={6} className="text-end">
                          <Button variant="primary" onClick={handleNextClick}>
                            Next{" "}
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="ml-2"
                            />
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Tab.Pane>

                  {/* Processing tab content */}
                  <Tab.Pane eventKey="Processing">
                    <Form>
                      {/* Processing information fields */}

                      <Row>
                        <Col md={6} className="mb-3">
                          <Form.Group id="merchants">
                            <RequiredLabel>
                              Do You Currently Accept Credit Cards
                            </RequiredLabel>
                            <Form.Select
                              defaultValue="0"
                              value={formData.credit_card}
                              onChange={handleChange}
                              name="credit_card"
                              isInvalid={!!errors.credit_card} // Add error chec
                            >
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.credit_card}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="merchants">
                            <RequiredLabel>
                              Have You Ever Processed Before
                            </RequiredLabel>
                            <Form.Select
                              defaultValue="0"
                              value={formData.processed_before}
                              onChange={handleChange}
                              name="processed_before"
                              isInvalid={!!errors.processed_before} // Add error chec
                            >
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.processed_before}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="merchants">
                            <RequiredLabel>
                              Have You Ever Had Merchant Account Terminated
                            </RequiredLabel>
                            <Form.Select
                              defaultValue="0"
                              value={
                                formData.merchant_account_termination_status
                              }
                              onChange={handleChange}
                              name="merchant_account_termination_status"
                              isInvalid={
                                !!errors.merchant_account_termination_status
                              } // Add error chec
                            >
                              <option value="0">No</option>
                              <option value="1">Yes</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.merchant_account_termination_status}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="contactname">
                            <RequiredLabel>
                              If Yes Please State The Reason
                            </RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter please state the reason"
                              value={
                                formData.merchant_account_termination_reason
                              }
                              onChange={handleChange}
                              name="merchant_account_termination_reason"
                              isInvalid={
                                !!errors.merchant_account_termination_reason
                              } // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.merchant_account_termination_reason}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="tollfreeno">
                            <RequiredLabel>Former / Current Processor</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter former / current processor"
                              value={formData.processor}
                              onChange={handleChange}
                              name="processor"
                              isInvalid={!!errors.processor} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.processor}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="contactemail">
                            <RequiredLabel>Time With Processor</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter time with processor"
                              value={formData.time_with_processor}
                              onChange={handleChange}
                              name="time_with_processor"
                              isInvalid={!!errors.time_with_processor} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.time_with_processor}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>

                        <hr />
                        <Col md={6}>
                          <Button
                            variant="primary"
                            onClick={handlePreviousClick}
                          >
                            <FontAwesomeIcon
                              icon={faArrowLeft}
                              className="me-1"
                            />{" "}
                            Previous
                          </Button>
                        </Col>
                        <Col md={6} className="text-end">
                          <Button variant="primary" onClick={handleNextClick}>
                            Next{" "}
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="ml-2"
                            />
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Tab.Pane>

                  {/* Transaction tab content */}
                  <Tab.Pane eventKey="Transaction">
                    <Form>
                      {/* Transaction information fields */}

                      <Row>
                        <Col md={12} className="mb-3">
                          <Form.Group id="websiteurl">
                            <RequiredLabel>Estimated Total Sales/Month</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter estimated total sales/Month"
                              value={formData.total_sales}
                              onChange={handleChange}
                              name="total_sales"
                              isInvalid={!!errors.total_sales} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.total_sales}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mb-3">
                          <Form.Group id="Address">
                            <RequiredLabel>
                              Number Of Transactions/Month
                            </RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter number of transactions/month"
                              value={formData.no_of_trans_per_mnth}
                              onChange={handleChange}
                              name="no_of_trans_per_mnth"
                              isInvalid={!!errors.no_of_trans_per_mnth} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.no_of_trans_per_mnth}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mb-3">
                          <Form.Group id="Descriptor">
                            <RequiredLabel>Minimum Ticket Amount</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter minimum ticket amount"
                              value={formData.minimum_ticket_amount}
                              onChange={handleChange}
                              name="minimum_ticket_amount"
                              isInvalid={!!errors.minimum_ticket_amount} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.minimum_ticket_amount}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mb-3">
                          <Form.Group id="Descriptor">
                            <RequiredLabel>Maximum Ticket Amount</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              name="maximum_ticket_amount"
                              placeholder="Enter maximum ticket amount"
                              value={formData.maximum_ticket_amount}
                              onChange={handleChange}
                              isInvalid={!!errors.maximum_ticket_amount} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.maximum_ticket_amount}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <hr />
                        <Col md={6}>
                          <Button
                            variant="primary"
                            onClick={handlePreviousClick}
                          >
                            <FontAwesomeIcon
                              icon={faArrowLeft}
                              className="me-1"
                            />{" "}
                            Previous
                          </Button>
                        </Col>
                        <Col md={6} className="text-end">
                          <Button variant="primary" onClick={handleNextClick}>
                            Next{" "}
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="ml-2"
                            />
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Tab.Pane>

                  {/* Bank tab content */}
                  <Tab.Pane eventKey="Bank">
                    <Form>
                      {/* Bank information fields */}

                      <Row>
                        <Col md={6} className="mb-3">
                          <Form.Group id="websiteurl">
                            <RequiredLabel>Account Holder Name</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter account holder name"
                              value={formData.account_holder_name}
                              name="account_holder_name"
                              onChange={handleChange}
                              isInvalid={!!errors.account_holder_name} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.account_holder_name}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Address">
                            <RequiredLabel>Account Holder Address</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter account holder address"
                              value={formData.account_holder_address}
                              name="account_holder_address"
                              onChange={handleChange}
                              isInvalid={!!errors.account_holder_address} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.account_holder_address}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Descriptor">
                            <RequiredLabel>Account Holder Country</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter account holder country"
                              value={formData.account_holder_country}
                              name="account_holder_country"
                              onChange={handleChange}
                              isInvalid={!!errors.account_holder_country} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.account_holder_country}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Descriptor">
                            <RequiredLabel>Bank Name</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter bank name"
                              value={formData.bank_name}
                              name="bank_name"
                              onChange={handleChange}
                              isInvalid={!!errors.bank_name} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.bank_name}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        {/* <Col md={6} className="mb-3">
            <Form.Group id="Descriptor">
              <RequiredLabel>Bank Name</RequiredLabel>
              <Form.Control required type="text" placeholder="Enter bank name" />
            </Form.Group>
          </Col> */}
                        <Col md={6} className="mb-3">
                          <Form.Group id="Descriptor">
                            <RequiredLabel>Bank Address</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter bank address"
                              value={formData.bank_address}
                              name="bank_address"
                              onChange={handleChange}
                              isInvalid={!!errors.bank_address} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.bank_address}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Descriptor">
                            <RequiredLabel>Bank Country</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter bank country"
                              value={formData.bank_country}
                              name="bank_country"
                              onChange={handleChange}
                              isInvalid={!!errors.bank_country} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.bank_country}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Descriptor">
                            <RequiredLabel>Bank SWIFT</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter bank SWIFT"
                              value={formData.bank_swift}
                              name="bank_swift"
                              onChange={handleChange}
                              isInvalid={!!errors.bank_swift} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.bank_swift}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Descriptor">
                            <RequiredLabel>Bank Routing Number</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter bank routing number"
                              value={formData.bank_routing_no}
                              name="bank_routing_no"
                              onChange={handleChange}
                              isInvalid={!!errors.bank_routing_no} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.bank_routing_no}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Descriptor">
                            <RequiredLabel>Bank Account Number</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter bank account number"
                              value={formData.bank_account_number}
                              name="bank_account_number"
                              onChange={handleChange}
                              isInvalid={!!errors.bank_account_number} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.bank_account_number}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={6} className="mb-3">
                          <Form.Group id="Descriptor">
                            <RequiredLabel>Additional Information</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter additional information"
                              value={formData.bank_additional_info}
                              name="bank_additional_info"
                              onChange={handleChange}
                              isInvalid={!!errors.bank_additional_info} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.bank_additional_info}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <hr />
                        <Col md={6}>
                          <Button
                            variant="primary"
                            onClick={handlePreviousClick}
                          >
                            <FontAwesomeIcon
                              icon={faArrowLeft}
                              className="me-1"
                            />{" "}
                            Previous
                          </Button>
                        </Col>
                        <Col md={6} className="text-end">
                          <Button variant="primary" onClick={handleNextClick}>
                            Next{" "}
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="ml-2"
                            />
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Tab.Pane>

                  {/* Other tab content */}
                  <Tab.Pane eventKey="Other">
                    <Form>
                      {/* Other information fields */}

                      <Row>
                        <Col md={12} className="mb-3">
                          <Form.Group id="websiteurl">
                            <RequiredLabel>How Did You Hear About Us?</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter how did you hear about us?"
                              value={formData.about_us}
                              name="about_us"
                              onChange={handleChange}
                              isInvalid={!!errors.about_us} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.about_us}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md={12} className="mb-3">
                          <Form.Group id="Address">
                            <RequiredLabel>Name Of Agent</RequiredLabel>
                            <Form.Control
                              required
                              type="text"
                              placeholder="Enter name of agent"
                              value={formData.agent_name}
                              name="agent_name"
                              onChange={handleChange}
                              isInvalid={!!errors.agent_name} // Add error chec
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors.agent_name}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <hr />
                        <Col md={6}>
                          <Button
                            variant="primary"
                            onClick={handlePreviousClick}
                          >
                            <FontAwesomeIcon
                              icon={faArrowLeft}
                              className="me-1"
                            />{" "}
                            Previous
                          </Button>
                        </Col>
                        <Col md={6} className="text-end">
                          <Button variant="primary" onClick={handleSubmit}>
                            Save{" "}
                            <FontAwesomeIcon
                              icon={faThumbsUp}
                              className="ml-2"
                            />
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Card.Body>
      </Card>
    </>
  );
};

export default Addapplication;
